import React from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useAuth from '../hooks/useAuth';

// Profile Pages
import ProfileLayout from '../components/Layout/ProfileLayout';
import ProfilePage from '../pages/Profile/ProfilePage';
import SettingsPage from '../pages/Profile/SettingsPage';

// Protected Route - declarative redirect (no useEffect) to avoid "Maximum update depth exceeded"
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const { user } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (user && user.email_verified === false) {
    return <Navigate to="/verify-email" replace state={{ email: user.email, from: location }} />;
  }

  return children;
};

const ProfileRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <ProfileLayout>
              <ProfilePage />
            </ProfileLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <ProfileLayout>
              <SettingsPage />
            </ProfileLayout>
          </ProtectedRoute>
        }
      />
      {/* Redirect flower shop routes to visa applications */}
      <Route 
        path="/orders" 
        element={<Navigate to="/visa/applications" replace />} 
      />
      <Route 
        path="/points" 
        element={<Navigate to="/visa/applications" replace />} 
      />
      <Route 
        path="/promocodes" 
        element={<Navigate to="/visa/applications" replace />} 
      />
      <Route 
        path="/favorites" 
        element={<Navigate to="/visa/applications" replace />} 
      />
      <Route 
        path="/cart" 
        element={<Navigate to="/visa/applications" replace />} 
      />
      {/* Redirect any other profile routes to the main profile page */}
      <Route 
        path="*" 
        element={
          <ProtectedRoute>
            <Navigate to="/" replace />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
};

export default ProfileRoutes;
